import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את התחושה",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה לתקן את עצמי.",
      "אני רק מזהה: יש בי תחושת לא שייך/ת."
    ],
      [
      "היום אני לא מנסה לתקן את עצמי.",
      "אני רק מזהה: יש בי תחושת לא שייך/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי התחושה הזו הכי חזקה?",
      "מה עולה בי יחד איתה?",
      "איזה משפט פנימי חוזר?"
    ],
      [
      "מתי התחושה הזו הכי חזקה?",
      "מה עולה בי יחד איתה?",
      "איזה משפט פנימי חוזר?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "תחושה היא חוויה, לא זהות."
    ],
      [
      "תחושה היא חוויה, לא זהות."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני רואה את התחושה\".",
      "נשימה אחת + \"אני רואה את התחושה\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע שבו זה מופיע",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שהתחושה עולה.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני שם/ה לב לרגע שהתחושה עולה.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה רגע לפני שזה עולה?",
      "מי נמצא סביבי כשזה מופיע?",
      "מה אני מפחד/ת שיקרה שם?"
    ],
      [
      "מה קורה רגע לפני שזה עולה?",
      "מי נמצא סביבי כשזה מופיע?",
      "מה אני מפחד/ת שיקרה שם?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשהרגע ברור, יש לי מעט מרחב."
    ],
      [
      "כשהרגע ברור, יש לי מעט מרחב."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשהתחושה עולה.",
      "נשימה אחת כשהתחושה עולה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "אותות הגוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה התחושה יושבת בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ],
      [
      "איפה התחושה יושבת בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף מנסה לשמור עלי."
    ],
      [
      "הגוף מנסה לשמור עלי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפור מול עובדה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה היבשה כאן?",
      "איזה סיפור קפץ לי?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ],
      [
      "מה העובדה היבשה כאן?",
      "איזה סיפור קפץ לי?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "ההשוואה שלי",
    opening: localizedGenderNode(
      [
      "היום אני רואה איך ההשוואה מזינה את התחושה.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני רואה איך ההשוואה מזינה את התחושה.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת רגע בשקט.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת רגע בשקט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מול מי אני משווה את עצמי?",
      "מה נראה לי שחסר בי שם?",
      "מה אני כן מביא/ה איתי?"
    ],
      [
      "מול מי אני משווה את עצמי?",
      "מה נראה לי שחסר בי שם?",
      "מה אני כן מביא/ה איתי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "השוואה היא הרגל, לא אמת."
    ],
      [
      "השוואה היא הרגל, לא אמת."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"אני לא רוצה/ת להשוות\".",
      "משפט פנימי - \"אני לא רוצה/ת להשוות\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הקול שמבפנים",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לקול שאומר \"אני לא שייך/ת\".",
      "בלי להילחם בו."
    ],
      [
      "היום אני מקשיב/ה לקול שאומר \"אני לא שייך/ת\".",
      "בלי להילחם בו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הקול הזה נשמע?",
      "מה הוא מנסה להגן עליו?",
      "מה הייתי רוצה לומר לו?"
    ],
      [
      "איך הקול הזה נשמע?",
      "מה הוא מנסה להגן עליו?",
      "מה הייתי רוצה לומר לו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול הוא רק קול."
    ],
      [
      "קול הוא רק קול."
    ]
    ),
    action: localizedGenderNode(
      "לשים לב אליו בלי להאמין לו.",
      "לשים לב אליו בלי להאמין לו."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הצורך בשייכות",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך להיות שייך/ת.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נוגע/ת בצורך להיות שייך/ת.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה כדי להרגיש שייך/ת?",
      "איפה אני כן מרגיש/ה שייך/ת?",
      "מה רגע קטן של שייכות עבורי?"
    ],
      [
      "מה אני בוחר/ת/ה כדי להרגיש שייך/ת?",
      "איפה אני כן מרגיש/ה שייך/ת?",
      "מה רגע קטן של שייכות עבורי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שייכות היא צורך אנושי."
    ],
      [
      "שייכות היא צורך אנושי."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב רגע אחד שכן הרגשתי בו שייך/ת.",
      "לכתוב רגע אחד שכן הרגשתי בו שייך/ת."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "עוגן קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת עוגן קטן כשאני עם אנשים.",
      "לא גדול."
    ],
      [
      "היום אני בוחר/ת עוגן קטן כשאני עם אנשים.",
      "לא גדול."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עוזר לי להישאר עם עצמי?",
      "איזה עוגן קטן אפשרי לי?",
      "איך זה מרגיש כשאני נשאר/ת איתי?"
    ],
      [
      "מה עוזר לי להישאר עם עצמי?",
      "איזה עוגן קטן אפשרי לי?",
      "איך זה מרגיש כשאני נשאר/ת איתי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עוגן קטן יכול להספיק."
    ],
      [
      "עוגן קטן יכול להספיק."
    ]
    ),
    action: localizedGenderNode(
      "להרגיש את כפות הרגליים לרגע.",
      "להרגיש את כפות הרגליים לרגע."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "שפה פנימית רכה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ],
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מדבר/ת אל עצמי כשאני לא שייך/ת?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ],
      [
      "איך אני מדבר/ת אל עצמי כשאני לא שייך/ת?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול רך מוריד לחץ."
    ],
      [
      "קול רך מוריד לחץ."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט הרך פעם אחת.",
      "לומר את המשפט הרך פעם אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "לפני שאני מתחבא/ת",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני שאני נסגר/ת.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני שאני נסגר/ת.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף להסתתר.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף להסתתר.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני יודע/ת שאני נסגר/ת?",
      "מה אני מנסה להגן עליו שם?",
      "מה יכול לעזור לי להישאר רגע?"
    ],
      [
      "איך אני יודע/ת שאני נסגר/ת?",
      "מה אני מנסה להגן עליו שם?",
      "מה יכול לעזור לי להישאר רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עצירה קטנה משנה את הסיפור."
    ],
      [
      "עצירה קטנה משנה את הסיפור."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני שאני נסגר/ת.",
      "נשימה אחת לפני שאני נסגר/ת."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "לחזור להווה",
    opening: localizedGenderNode(
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ],
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ],
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ההווה נותן לי קרקע."
    ],
      [
      "ההווה נותן לי קרקע."
    ]
    ),
    action: localizedGenderNode(
      "להרגיש את כפות הרגליים לרגע.",
      "להרגיש את כפות הרגליים לרגע."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "רגע לפני נסיגה",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני שאני מתרחק/ת.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני שאני מתרחק/ת.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף לברוח.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף לברוח.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מנסה להתרחק?",
      "מה יקרה אם אשאר רגע?",
      "מה יכול לתמוך בי ברגע הזה?"
    ],
      [
      "ממה אני מנסה להתרחק?",
      "מה יקרה אם אשאר רגע?",
      "מה יכול לתמוך בי ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן משנה כיוון."
    ],
      [
      "רגע קטן משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני נסיגה.",
      "נשימה אחת לפני נסיגה."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן שמחזיר אותי לעצמי.",
      "לא מהפכה."
    ],
      [
      "היום אני בוחר/ת צעד קטן שמחזיר אותי לעצמי.",
      "לא מהפכה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה צעד קטן יכול לעזור לי להישאר?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ],
      [
      "איזה צעד קטן יכול לעזור לי להישאר?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק הוא מספיק."
    ],
      [
      "קטן מספיק הוא מספיק."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד קטן אחד.",
      "לבחור צעד קטן אחד."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ],
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על התחושה הזו?",
      "מה הסימן הראשון שהיא עולה?",
      "מה המשפט הקצר שלי?"
    ],
      [
      "מה למדתי על התחושה הזו?",
      "מה הסימן הראשון שהיא עולה?",
      "מה המשפט הקצר שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת רגע לפני תגובה."
    ],
      [
      "אני בוחר/ת רגע לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + המשפט שלי.",
      "נשימה אחת + המשפט שלי."
    ),
  },
].map(buildNormalizedDay);

export const feelingStrangeNotBelongBlueprintHe = buildNormalizedPilotBlueprint({
  id: "feeling_strange_not_belong_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "feeling_strange_not_belong",
  category: "anxiety",
  journeyName: {
    he: "תחושת \"אני מוזר/ה, לא שייך/ת\"",
    en: "Feeling \"I'm strange, I don't belong\"",
    es: "Sentir \"soy extrano/a, no pertenezco\"",
  },
  days,
});

export default feelingStrangeNotBelongBlueprintHe;
